import {axiosInstance, getExecutorWebBaseUrl} from '@rocket-ui/lk-api';

declare const __LK_API_ORIGIN__: string | undefined;

export type AuthorizedReceiptRequest = {
	url: string;
};

function executorOrigin(): string {
	return new URL(getExecutorWebBaseUrl(), window.location.origin).origin;
}

function apiDocumentOrigin(): string {
	const configured = typeof __LK_API_ORIGIN__ === 'string' ? __LK_API_ORIGIN__.trim().replace(/\/$/, '') : '';
	if (configured) return configured;

	return executorOrigin();
}

/** Page URL on API_URL. srcdoc otherwise resolves relative links against the SPA host. */
export function toApiDocumentUrl(rawUrl: string): string {
	const resolved = new URL(toAbsoluteExecutorUrl(rawUrl), window.location.origin);

	return `${apiDocumentOrigin()}${resolved.pathname}${resolved.search}${resolved.hash}`;
}

function escapeHtmlAttribute(value: string): string {
	return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

/** `<base>` makes relative href, src, action, and request URLs resolve against API_URL. */
export function withApiDocumentBase(html: string, documentUrl: string): string {
	const base = `<base href="${escapeHtmlAttribute(documentUrl)}">`;
	const withoutBase = html.replace(/<base\b[^>]*>/gi, '');

	if (/<head[^>]*>/i.test(withoutBase)) {
		return withoutBase.replace(/<head([^>]*)>/i, `<head$1>${base}`);
	}

	return `${base}${withoutBase}`;
}

export function toAbsoluteExecutorUrl(rawUrl: string): string {
	const origin = executorOrigin();
	const resolved = new URL(rawUrl, window.location.origin);

	if (resolved.pathname === '/executor_web' || resolved.pathname.startsWith('/executor_web/')) {
		return `${origin}${resolved.pathname}${resolved.search}${resolved.hash}`;
	}

	return resolved.href;
}

export async function fetchAuthorizedReceiptHtml(request: AuthorizedReceiptRequest): Promise<string> {
	const response = await axiosInstance.request<string>({
		url: toAbsoluteExecutorUrl(request.url),
		method: 'GET',
		responseType: 'text',
		headers: {
			Accept: 'text/html,application/xhtml+xml',
		},
		transformResponse: [(body: unknown) => body],
	});

	return typeof response.data === 'string' ? response.data : String(response.data ?? '');
}
